export const extendedTrial = 'extended-trial'
